import { Modal, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import * as S from './style';

function TotalEstimatedSpendAutomationModal({ isModalOpen, onModalOpen }) {
  const { t } = useTranslation();
  const pricingListData = t('pricingListAutomationData', { returnObjects: true });

  const conditions = {};

  return (
    <Modal
      size="sm"
      title={t('howOurPriceWork')}
      isOpen={isModalOpen}
      onRequestClose={onModalOpen}
      primaryButtonProps={{
        onClick: () => onModalOpen(false),
        children: t('okay')
      }}
    >
      <S.PricingList>
        {pricingListData?.map(pricing => {
          const answersWithConditions = pricing?.answers?.[!!conditions?.[pricing?.condition]];
          const answers =
            pricing?.condition && !!answersWithConditions?.length
              ? answersWithConditions
              : pricing?.answers;

          return (
            <S.Pricing key={pricing.title}>
              <Typography variant="body1Bold">
                <Trans i18nKey={pricing.title} components={{ b: <b /> }} />
              </Typography>

              <S.PricingAnswers>
                {answers?.map(answer => {
                  return (
                    <Typography variant="body2" key={answer}>
                      <Trans i18nKey={answer} components={{ b: <b /> }} />
                    </Typography>
                  );
                })}
              </S.PricingAnswers>
            </S.Pricing>
          );
        })}
      </S.PricingList>
    </Modal>
  );
}

export { TotalEstimatedSpendAutomationModal };
